import { render, staticRenderFns } from "./TaskDefinitionAdd.vue?vue&type=template&id=7fbf08ba&scoped=true"
import script from "./TaskDefinitionAdd.vue?vue&type=script&lang=js"
export * from "./TaskDefinitionAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbf08ba",
  null
  
)

export default component.exports